import { useEffect, useRef, useState } from 'react'

export const useInView = (options = {}, startVisible = false) => {
  const ref = useRef(null)
  const [isVisible, setIsVisible] = useState(startVisible)

  useEffect(() => {
    if (startVisible) return undefined

    const element = ref.current
    if (!element) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.unobserve(element)
        }
      },
      { threshold: 0.15, ...options }
    )

    observer.observe(element)

    return () => observer.disconnect()
  }, [options, startVisible])

  return { ref, isVisible }
}
